<style lang="scss" scoped>
.check {
    position: relative;
    cursor: pointer;
    font-size: 0;
    vertical-align: middle;
    color: inherit;
    input {
        position: absolute;
        visibility: hidden;
        opacity: 0;
    }
    .label {
        font-size: 12px;
        vertical-align: middle;
    }
}
</style>

<template>
    <label class="check">
        <input type="radio" :checked="isChecked" @change="update">
        <span v-if="round">
            <i class="icons" :class="[isChecked ? 'icon-checkbox-round-checked' : 'icon-checkbox-round-uncheck']"></i>
        </span>
        <span v-else>
            <i class="icons" :class="[isChecked ? 'icon-checkbox-checked' : 'icon-checkbox-uncheck']"></i>
        </span>
        <span class="label"><slot></slot></span>
    </label>
</template>

<script>
export default {
    name: 'radio',
    props: {
        value: [String, Number, Boolean],
        data: [String, Number, Boolean],
        round: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isChecked() {
            return this.value == this.data
        }
    },
    methods: {
        update() {
            this.$emit('input', this.data)
        }
    }
}
</script>





// WEBPACK FOOTER //
// src/components/check/radio.vue